import type { EntityRegistry } from '@sites/entity-migrator';

import { WebsiteThemeEntitySchema, type WebsiteTheme } from './schemas';

/**
 * Which schema a stored theme is read through.
 *
 * The discriminator is `entitySubType`, matching how sections pick between default/specific/zero.
 * A blob with neither tag nor version is pre-versioning and goes to the website variant, the only
 * variant this package serves. Mini-landing's `simple` variant lives in `@libs/themes` and is not
 * versioned at all — it never reaches this registry.
 */
export const themeRegistry: EntityRegistry<WebsiteTheme> = {
    name: 'theme',
    getEntitySchema: (entity: unknown) => {
        if (typeof entity !== 'object' || entity === null) return null;

        const { entitySubType, version } = entity as { entitySubType?: unknown; version?: unknown };

        if (entitySubType === 'website') return WebsiteThemeEntitySchema;

        if (entitySubType === undefined && version === undefined) return WebsiteThemeEntitySchema;

        return null;
    },
};
